import type { QueryHookOptions } from "@apollo/client";
import { useQuery, gql } from "@apollo/client";

import type { Flipper } from "@shared/types/graphqlGenerated";

const Flippers_Shared_Query = gql`
  query Flippers_Shared_Query {
    viewer {
      flippers {
        id
        name
        result
      }
    }
  }
`;

type FlipperFragment = Pick<Flipper, "id" | "name" | "result">;
interface FlippersData {
  viewer: { flippers: FlipperFragment[] };
}

const useFlippersQuery = (options?: QueryHookOptions<FlippersData>) =>
  useQuery<FlippersData>(Flippers_Shared_Query, options);

export type { FlippersData };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { useFlippersQuery, Flippers_Shared_Query };
